<template lang="pug">
b-modal#addDefaultTemplate(
  ref="addDefaultTemplate"
  :title="$t('ui.combine.add_mini_game_template')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$tc('ui.template_code')").mb-1
      DebounceInput(
        size="sm"
        ref="template_code"
        required
        type="text"
        :dirty="$v.template_code.$dirty"
        :error="$v.template_code.$error"
        v-model.trim.lazy="$v.template_code.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.template_code" :name="$t('ui.template_code')")
    b-form-group(:label="$t('ui.template_name')").mb-1
      DebounceInput(
        size="sm"
        ref="template_name"
        required
        type="text"
        :dirty="$v.template_name.$dirty"
        :error="$v.template_name.$error"
        v-model.trim.lazy="$v.template_name.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.template_name" :name="$t('ui.template_name')")
    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import config from "@/config";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      template_code: '',
      template_name: ''
    };
  },
  validations: {
    template_code: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(30)
    },
    template_name: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(50)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.addDefaultTemplateUrl();

        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.loginId,
          template_code: this.template_code,
          template_name: this.template_name,
        };

        this.feedback.success = true;
        this.loading = true;

        this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "add_mini_game_template", this.feedback.status);
              }
              this.$nextTick(() => {
                this.$refs.addDefaultTemplate.hide();
              });
            }
          } catch (error) {
            this.loading = false;
            if (error.status.toLowerCase() == "nochanges") {
              this.$emit("clicked");
              this.$nextTick(() => {
                this.$refs.addDefaultTemplate.hide();
              });
            } else {
              this.feedback.success = false;
              this.feedback.status = error.status;
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.handleFeedback(this.feedback.status);
        }
      );
      }
    },
    reset() {
      this.template_code = "";
      this.template_name = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.$v.$reset();
      this.$refs.template_code.$el.focus();
    }
  }
};
</script>
